import { keyframes, styled } from '@styles/stitches';

const fadeIn = keyframes({
  from: { opacity: 0 },
  to: { opacity: 1 },
});

const fadeOut = keyframes({
  from: { opacity: 1 },
  to: { opacity: 0 },
});

export const Overlay = styled('div', {
  backgroundColor: 'hsl(0 0% 0% / 0.5439)',
  position: 'fixed',
  top: 0,
  inset: 0,
  zIndex: 1000,

  '@media (prefers-reduced-motion: no-preference)': {
    animation: `${fadeIn} 200ms ease-out`,
  },
});

export const Close = styled('button', {
  position: 'fixed',
  top: '$space$3',
  right: '$space$3',
  width: 32,
  height: 32,
  cursor: 'pointer',
  background: 'transparent',
  border: 0,
  zIndex: 100,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  '@bp1': {
    right: '$space$2',
  },

  '@bp2': {
    right: '$space$1',
  },

  '&:before': {
    content: "''",
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    borderRadius: 9999,
    backgroundColor: '$primaryBackground',
    opacity: 0.3,
    zIndex: -1,
  },

  i: {
    color: '$secondaryFill',
  },

  '&:hover': {
    i: {
      color: '$primaryFill',
    },
  },

  '&:focus': {
    outline: 0,
    i: {
      color: '$primaryFill',
    },
  },
});

export const Content = styled('div', {
  width: '100vw',
  height: '100vh',
  backgroundColor: '$primaryBackground',

  '&:focus': { outline: 'none' },

  '@media (prefers-reduced-motion: no-preference)': {
    animation: `${fadeIn} 200ms ease-out`,

    '&[data-state="closed"]': {
      animation: `${fadeOut} 100ms ease-out`,
    },
  },
});

export const Scrollable = styled('div', {
  overflowY: 'auto',
});

export const Container = styled('div', {
  width: '100vw',
  height: 'calc(100vh - $space$1)',
  marginTop: '$space$1',
});
